import BaseApi from '../BaseApi';

class NewYearApi extends BaseApi {
    constructor(baseUrl) {
      super(baseUrl);
      this.baseUrl = `${baseUrl}/api/common`;
    }

    getUserNewYearStatistic = (userId) => this.sendQuery(
        this.queryTypes.POST,
        `${this.baseUrl}/get_new_year_statistic`,
        { user_id: userId }
    )
  }
  
  export default NewYearApi;